// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2_iAT","question":"styles_question__1Y3hF","description":"styles_description__NuZDU"};